import React, { Fragment, useState, useEffect } from "react";
import { Col, Row } from "reactstrap";
import AuthorizationComponent from "../components/Authorization/AuthorizationComponent";
import { PageWrapper } from "../components/PageWrapper/PageWrapper";
import { CloseCustodianEntity } from "bx-react-ui/src/components/Modal/CounterPartySet/reducer";

import SidebarOnboarding from "../components/SidebarOnboarding/Sidebaronboarding";

export const Onboarding = () => {
  return (
    <div style={{width: 'vw', height: 'vh', top: 0, left: 0, zIndex: 1049, position: 'absolute'}}>
      <SidebarOnboarding title={"Sidebar Onboarding"}></SidebarOnboarding>
    </div>
    
  );
};
